import api from "../api";

export async function UpdateDetails(user_id, formData) {
  return await api({
    method: "put",
    url: `${process.env.REACT_APP_API_URL}/admin/common/update-details/${user_id}`,
    data: formData,
  });
}

export async function getUserActivityLogs(params = {}) {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/common/getUserActivityLogs`,
    params,
  });
}

export async function getAdminLogsData(params = {}) {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/common/getAdminLogs`,
    params,
  });
}

export async function getRoundsData() {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/common/getroundslist`,
  });
}

export async function getAllSkills() {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/skill/list`,
  });
}
